import { Cancel, CheckCircle } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Chip, Divider, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function OrderCard({ order }) {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={t("Order details")} />
            <Divider />
            <CardContent>
                <Box my={10} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontWeight: "bold" }}>{t("Order number")}</Typography>
                    <Chip size="small" label={order?.orderNumber} variant="outlined" color="primary" />
                </Box>
                <Box my={10} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontWeight: "bold" }}>{t("Date created")}</Typography>
                    <Chip size="small" label={moment(order?.createdAt).format("DD/MM/YY - h:mm A")} variant="outlined" color="primary" />
                </Box>
                {!!order?.items &&
                    <>
                        <Divider sx={{ my: 15 }} />
                        {
                            Object.keys(order?.items).map(key => (
                                <Box>
                                    <Typography sx={{ fontWeight: "bold", mb: 5 }} color="primary" variant='h6'>{key}</Typography>
                                    <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography sx={{ fontWeight: "bold" }}>{`${t("Count")} : `}</Typography>
                                        <Chip color="primary" size="small" variant="outlined" label={order?.items[key].count} />
                                        <Typography sx={{ fontWeight: "bold" }}>{`${t("Express")} : `}</Typography>
                                        {order?.items[key]?.express ? <CheckCircle color="success" /> : <Cancel color="error" />}
                                        <Typography sx={{ fontWeight: "bold" }}>{`${t("Price")} : `}</Typography>
                                        <Chip color="primary" size="small" variant="outlined" label={t("MONEY", { money: order?.items[key].price })} />
                                    </Box>
                                    <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography sx={{ fontWeight: "bold" }} variant='subtitle2'>{`${t("Shield count")} : `}</Typography>
                                        <Chip color="primary" size="small" variant="outlined" label={order?.items[key]?.shield?.count} />
                                        <Typography sx={{ fontWeight: "bold" }} variant='subtitle2'>{`${t("Shield price")} : `}</Typography>
                                        <Chip color="primary" size="small" variant="outlined" label={t("MONEY", { money: order?.items[key]?.shield?.price })} />
                                    </Box>
                                </Box>
                            ))
                        }
                    </>
                }
            </CardContent>
        </Card>
    )
}
